/**
 * Cart Drawer - KraftCover
 */
(function () {
  'use strict';

  class TBDrawer {
    constructor() {
      this.drawer = document.querySelector('#tb-drawer');
      this.overlay = document.querySelector('#tb-overlay');
      if (!this.drawer) return;
      this.busy = false;
      this.bind();
      this.hijack();
      this.initNote();
      /* Sayfa yuklenince onerileri yukle */
      this.getCart().then(c => {
        if (c.item_count > 0) this.loadRecs(c);
        this.loadFreeShipUpsell(c);
        this.loadOffers(c);
      });
    }

    /* ===== SİPARİŞ NOTU ===== */
    initNote() {
      const wrap = document.querySelector('#tb-note');
      const toggle = document.querySelector('#tb-note-toggle');
      const body = document.querySelector('#tb-note-body');
      const input = document.querySelector('#tb-note-input');
      const status = document.querySelector('#tb-note-status');
      if (!wrap || !toggle || !input) return;
      this._noteSaved = input.value;

      toggle.addEventListener('click', () => {
        const open = wrap.classList.toggle('is-open');
        body.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) input.focus();
      });

      let noteTimer;
      const save = () => {
        clearTimeout(noteTimer);
        const val = input.value;
        if (val === this._noteSaved) return Promise.resolve();
        // keepalive: navigation başlasa bile request tamamlanır
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: val }),
          keepalive: true
        }).then(r => {
          if (!r.ok) return;
          this._noteSaved = val;
          if (status) {
            status.textContent = 'Kaydedildi';
            status.classList.add('is-visible');
            clearTimeout(this._noteStatusTimer);
            this._noteStatusTimer = setTimeout(() => status.classList.remove('is-visible'), 1800);
          }
        }).catch(() => {});
      };

      input.addEventListener('input', () => { clearTimeout(noteTimer); noteTimer = setTimeout(save, 700); });
      input.addEventListener('blur', save);
      // Sekme kapanır/gizlenirse debounce'u beklemeden flush (keepalive unload'da da tamamlar)
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') save(); });
      window.addEventListener('pagehide', save);
      // Checkout: kaydedilmemiş not varsa navigation'ı durdur, kaydı bekle, sonra geç (1.2s emniyet tavanı)
      document.querySelector('.tb-checkout')?.addEventListener('click', (e) => {
        if (input.value === this._noteSaved) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        let gone = false;
        const go = () => { if (!gone) { gone = true; window.location = '/checkout'; } };
        save().then(go, go);
        setTimeout(go, 1200);
      }, { capture: true });
    }

    /* ===== EVENTS ===== */
    bind() {
      this.overlay.addEventListener('click', () => this.close());
      document.querySelector('#tb-close')?.addEventListener('click', () => this.close());
      document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
      document.querySelector('#tb-save')?.addEventListener('click', () => this.saveCart());

      this.drawer.addEventListener('click', e => {
        const btn = e.target.closest('[data-action]');
        if (btn) {
          e.preventDefault();
          const key = btn.dataset.key;
          const act = btn.dataset.action;
          if (act === 'increase') this.changeQty(key, 1);
          else if (act === 'decrease') this.changeQty(key, -1);
          else if (act === 'remove') this.removeItem(key);
          return;
        }
        const addBtn = e.target.closest('.tb-rec__add');
        if (addBtn) { e.preventDefault(); this.addToCart(addBtn.dataset.vid); return; }

        const swatch = e.target.closest('.tb-rec__swatch[data-swatch-vid]');
        if (swatch) { e.preventDefault(); this.selectSwatch(swatch); return; }

        const ropeSw = e.target.closest('[data-rope-swatch]');
        if (ropeSw) { e.preventDefault(); this.selectRopeSwatch(ropeSw); return; }

        const carabSw = e.target.closest('[data-carab-swatch]');
        if (carabSw) { e.preventDefault(); this.selectCarabSwatch(carabSw); return; }

        const fsBtn = e.target.closest('[data-fs-add]');
        if (fsBtn) { e.preventDefault(); this.addToCart(fsBtn.dataset.vid); return; }
      });

      document.addEventListener('click', e => {
        if (e.target.closest('#tb-recs-prev')) this.scrollRecs(-1);
        if (e.target.closest('#tb-recs-next')) this.scrollRecs(1);
      });
    }

    hijack() {
      // Capture-phase + stopImmediatePropagation. Focal's <product-form> custom
      // element binds its OWN _onSubmit on the form (target phase) and also
      // POSTs /cart/add.js — without intercepting in capture, BOTH listeners
      // fire and the same item gets added twice. The kc-bundle.js submit
      // handler is also on document.body capture and registers earlier; if it
      // chose to handle a checked bundle it calls stopImmediatePropagation
      // and ours never fires. So this is the catch-all for non-bundle adds.
      if (window.__tbDrawerSubmitBound) return;
      window.__tbDrawerSubmitBound = true;
      document.body.addEventListener('submit', (e) => {
        const f = e.target;
        if (!(f instanceof HTMLFormElement)) return;
        if (!f.action || !f.action.includes('/cart/add')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        this.addFromForm(new FormData(f), f);
      }, true);

      document.addEventListener('click', e => {
        const a = e.target.closest('a[href="/cart"], a[href$="/cart"], [data-action="toggle-cart"]');
        if (a && !a.closest('#tb-drawer')) { e.preventDefault(); e.stopPropagation(); this.open(); }
      }, true);
    }

    /* ===== OPEN / CLOSE ===== */
    open() {
      // Remember where focus was so we can restore it on close (a11y: focus
      // return is a hard requirement for modal-style overlays — without it,
      // keyboard / SR users get dropped at <body> after the drawer closes).
      const active = document.activeElement;
      if (active && active !== document.body && !this.drawer.contains(active)) {
        this._lastFocus = active;
      }
      this.drawer.classList.add('is-open');
      this.overlay.classList.add('is-open');
      document.body.classList.add('tb-lock');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.drawer.querySelectorAll('button, a, input, textarea').forEach(el => el.removeAttribute('tabindex'));
      // Move focus inside the drawer (next paint, after CSS transition kicks in).
      requestAnimationFrame(() => {
        const closeBtn = this.drawer.querySelector('#tb-close');
        if (closeBtn) try { closeBtn.focus({ preventScroll: true }); } catch (_) { closeBtn.focus(); }
      });
      // Trap Tab inside the drawer while it's open.
      if (!this._tabTrap) {
        this._tabTrap = (e) => this._handleTabTrap(e);
        document.addEventListener('keydown', this._tabTrap, true);
      }
    }
    close() {
      this.drawer.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      document.body.classList.remove('tb-lock');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.drawer.querySelectorAll('button, a, input, textarea').forEach(el => el.setAttribute('tabindex', '-1'));
      if (this._tabTrap) {
        document.removeEventListener('keydown', this._tabTrap, true);
        this._tabTrap = null;
      }
      // Restore focus only if the previous element is still in the DOM and visible.
      const prev = this._lastFocus;
      this._lastFocus = null;
      if (prev && document.contains(prev) && prev.offsetParent !== null) {
        try { prev.focus({ preventScroll: true }); } catch (_) { prev.focus(); }
      }
    }

    _handleTabTrap(e) {
      if (e.key !== 'Tab') return;
      if (!this.drawer.classList.contains('is-open')) return;
      const focusables = Array.from(this.drawer.querySelectorAll(
        'button:not([disabled]), a[href], input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(el => el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;
      if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      } else if (!this.drawer.contains(active)) {
        // Focus escaped (e.g. clicked outside then tabbed) — pull it back in.
        e.preventDefault();
        first.focus();
      }
    }

    /* ===== API ===== */
    async api(url, opts) {
      const o = { credentials: 'same-origin', cache: 'no-store', ...opts };
      return (await fetch(url, o)).json();
    }
    async getCart() { return this.api('/cart.js'); }

    async addToCart(vid, qty = 1) {
      this.loading(true);
      await this.api('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: qty }] }),
      });
      await this.refresh();
      this.open();
      this.loading(false);
    }

    async addFromForm(fd, form) {
      const btn = form.querySelector('[type="submit"]');
      const orig = btn?.textContent;
      if (btn) { btn.disabled = true; btn.textContent = 'Ekleniyor'; }
      // Open the drawer IMMEDIATELY so the user sees instant feedback —
      // even on slow networks the spinner is visible while the request flies.
      this.open();
      this.setAdding(true);
      // Inject a "preparing" skeleton card at the top of the list. Tries to
      // pull the product title + image from the surrounding PDP so it reads
      // as "your selection is being added" instead of a generic skeleton.
      this.injectPending(this._sniffProductFromForm(form));
      try {
        await this.api('/cart/add.js', { method: 'POST', body: fd });
        await this.refresh();
      } finally {
        this.setAdding(false);
        this.clearPending();
        if (btn) { btn.disabled = false; btn.textContent = orig; }
      }
    }

    /* Heuristic: extract product title + featured image from the PDP DOM
       around the form. Works on Focal's main-product layout; degrades to
       a generic skeleton on unknown structures. */
    _sniffProductFromForm(form) {
      try {
        const root = form.closest('main, .main-product, [data-product-id], body') || document;
        const title =
          root.querySelector('.product-meta__title, .product__title, [data-product-title]')?.textContent?.trim() ||
          form.querySelector('[data-product-title]')?.textContent?.trim() || '';
        const imgEl =
          root.querySelector('.product-gallery__media-list img, .product-gallery__image, .product-media__image, .product__media img');
        const image = imgEl ? (imgEl.currentSrc || imgEl.src || '') : '';
        return { title, image, isBundle: false };
      } catch (_) {
        return { title: '', image: '', isBundle: false };
      }
    }

    /* Show an in-list "preparing" card at the top of #tb-scroll so the user
       sees their selection materialize before the API round-trip completes.
       Replaced naturally by renderItems() on refresh — no manual cleanup. */
    injectPending({ title, image, isBundle }) {
      const scroll = this.drawer.querySelector('#tb-scroll');
      if (!scroll) return;
      // Remove empty-state placeholder if present (cart was empty before add).
      const empty = scroll.querySelector('.tb-empty');
      if (empty) empty.remove();
      // Remove any prior pending card before adding a new one (rapid re-adds).
      this.clearPending();

      const card = document.createElement('div');
      card.className = 'tb-card tb-card--pending' + (isBundle ? ' tb-card--bundle' : '');
      card.setAttribute('aria-live', 'polite');
      card.setAttribute('aria-busy', 'true');

      const safeTitle = this.esc(title || (isBundle ? 'Paket' : 'Ürün'));
      const tagHtml = isBundle ? '<span class="tb-card__bundle-tag">PAKET</span>' : '';
      const imgHtml = image
        ? `<img src="${this.esc(image)}" alt="" loading="lazy">`
        : '<div class="tb-card__img-skel"></div>';

      card.innerHTML = `
        <div class="tb-card__top">
          <div class="tb-card__img">${imgHtml}</div>
          <div class="tb-card__info">
            <div class="tb-card__head">
              <div>
                <span class="tb-card__name">${tagHtml}${safeTitle}</span>
                <span class="tb-card__pending"><span class="tb-card__mini-spinner" aria-hidden="true"></span>Sepete ekleniyor</span>
              </div>
            </div>
          </div>
        </div>`;
      scroll.insertBefore(card, scroll.firstChild);
    }

    clearPending() {
      this.drawer.querySelectorAll('.tb-card--pending').forEach((el) => el.remove());
    }

    /* Toggle a top-of-drawer progress bar while an add/update is in-flight.
       Decouples "drawer opens" from "request completes" so the user gets
       immediate visual feedback even on slow connections. */
    setAdding(state) {
      let bar = this.drawer.querySelector('.tb-progress');
      if (state) {
        if (!bar) {
          bar = document.createElement('div');
          bar.className = 'tb-progress';
          bar.innerHTML = '<div class="tb-progress__fill"></div>';
          this.drawer.insertBefore(bar, this.drawer.firstChild);
        }
        bar.classList.add('is-active');
      } else if (bar) {
        bar.classList.remove('is-active');
      }
    }

    async changeQty(key, delta) {
      const el = this.drawer.querySelector(`.tb-qty__val[data-key="${key}"]`);
      if (!el) return;
      const prev = parseInt(el.textContent, 10) || 1;
      const next = Math.max(0, prev + delta);
      if (next === 0) return this.removeItem(key);
      el.textContent = next;
      try {
        await this.updateQty(key, next);
      } catch (err) {
        // Roll back optimistic display on failure; refreshFrom(null) below
        // will re-sync from server in case the partial update went through.
        el.textContent = prev;
        console.error('[tb-drawer]', err);
        await this.refreshFrom(null);
      }
    }

    /* Resolves a bundle's underlying source line keys via cart attribute set by kc-bundle.js. */
    async _bundleSourceKeys(uid, cart) {
      const c = cart || (await this.getCart());
      const raw = c.attributes && c.attributes[`_kc_bundle_${uid}`];
      if (!raw || typeof raw !== 'string') return null;
      const keys = raw.split(',').map((k) => k.trim()).filter(Boolean);
      return keys.length ? keys : null;
    }

    async updateQty(key, qty) {
      while (this.busy) await new Promise(r => setTimeout(r, 30));
      this.busy = true;
      try {
        const cart = await this.getCart();
        const item = cart.items.find((i) => i.key === key);
        const uid = item && item.properties && item.properties._bundle_uid;
        const sourceKeys = uid ? await this._bundleSourceKeys(uid, cart) : null;

        let nextCart = null;
        if (sourceKeys && sourceKeys.length) {
          // Bundle: scale ALL underlying source lines together
          const updates = {};
          sourceKeys.forEach((k) => { updates[k] = qty; });
          nextCart = await this.api('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates }),
          });
        } else if (item && item.key) {
          nextCart = await this.api('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [item.key]: qty } }),
          });
        }
        await this.refreshFrom(nextCart);
      } catch (err) {
        // Surface to caller (changeQty rolls back optimistic display).
        throw err;
      } finally {
        this.busy = false;
      }
    }

    async removeItem(key) {
      while (this.busy) await new Promise(r => setTimeout(r, 30));
      this.busy = true;
      const card = this.drawer.querySelector(`.tb-card[data-key="${key}"]`);
      try {
        const cart = await this.getCart();
        const item = cart.items.find((i) => i.key === key);
        const uid = item && item.properties && item.properties._bundle_uid;
        const sourceKeys = uid ? await this._bundleSourceKeys(uid, cart) : null;

        let nextCart = null;
        if (sourceKeys && sourceKeys.length) {
          // Bundle: nuke ALL underlying source lines + clear the cart attribute.
          // Use the response of /cart/update.js as the new cart state — avoids
          // a race where a follow-up GET /cart.js returns a stale snapshot.
          const updates = {};
          sourceKeys.forEach((k) => { updates[k] = 0; });
          nextCart = await this.api('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates, attributes: { [`_kc_bundle_${uid}`]: '' } }),
          });
        } else if (item && item.key) {
          // Non-bundle: use update.js with the line item's own key (more
          // reliable than change.js with merged-key inputs).
          nextCart = await this.api('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [item.key]: 0 } }),
          });
        }
        // Animate AFTER successful API write — if the write failed the card
        // shouldn't visually disappear and then reappear on refresh.
        if (card) { card.classList.add('is-removing'); await this.wait(280); }
        await this.refreshFrom(nextCart);
      } catch (err) {
        // Restore card visibility on failure.
        if (card) card.classList.remove('is-removing');
        console.error('[tb-drawer]', err);
        await this.refreshFrom(null);
      } finally {
        this.busy = false;
      }
    }

    /* Render directly from a known-good cart payload. Falls back to a fresh
       fetch if no payload was passed. Used to avoid post-mutation read races
       where the immediately-following GET /cart.js may reflect stale state. */
    async refreshFrom(cart) {
      const c = cart && typeof cart === 'object' && Array.isArray(cart.items) ? cart : await this.getCart();
      this.renderItems(c);
      this.renderFooter(c);
      this.updateBubble(c);
      this.loadRecs(c);
      this.loadOffers(c);
    }

    /* ===== REFRESH ===== */
    async refresh() {
      const cart = await this.getCart();
      this.renderItems(cart);
      this.renderFooter(cart);
      this.updateBubble(cart);
      this.loadRecs(cart);
      this.loadOffers(cart);
    }

    renderItems(cart) {
      const scroll = document.querySelector('#tb-scroll');
      const count = document.querySelector('#tb-count');
      if (count) count.textContent = cart.item_count;
      // Preserve scroll position across renders (qty +/-, single-item remove).
      // Without this, every quantity click jumps the list to top — jarring on long carts.
      const prevScrollTop = scroll ? scroll.scrollTop : 0;

      if (cart.item_count === 0) {
        scroll.innerHTML = `
          <div class="tb-empty">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>
            <p>Sepetiniz boş</p>
            <a href="/collections/all" class="tb-empty__btn">Alışverişe Başla</a>
          </div>`;
        return;
      }

      let h = '';
      cart.items.forEach(item => {
        const isBundle = !!(item.properties && item.properties._bundle_label && item.properties._bundle_original_price);
        let nameHtml, subtitleHtml = '';
        if (isBundle) {
          nameHtml = `<span class="tb-card__name"><span class="tb-card__bundle-tag">PAKET</span>${this.esc(item.title)}</span>`;
          // Prefer cart-attribute variants summary (per-bundle, JS-driven, includes variant + grouping).
          // Fallback to Function-set _bundle_subtitle (product titles only).
          let subtitle = '';
          const uid = item.properties && item.properties._bundle_uid;
          const variantsAttrKey = uid ? `_kc_bundle_${uid}_variants` : '';
          const variantsAttr = (variantsAttrKey && cart && cart.attributes) ? cart.attributes[variantsAttrKey] : '';
          if (variantsAttr && typeof variantsAttr === 'string') {
            subtitle = variantsAttr;
          } else if (item.properties && item.properties._bundle_subtitle) {
            subtitle = item.properties._bundle_subtitle;
          }
          if (subtitle) {
            const sep = subtitle.indexOf(' · ') >= 0 ? ' · ' : ' + ';
            const parts = subtitle.split(sep).map((p) => `<span class="tb-card__bundle-item">${this.esc(p.trim())}</span>`).join('');
            subtitleHtml = `<div class="tb-card__bundle-list">${parts}</div>`;
          }
        } else {
          nameHtml = `<a href="${item.url}" class="tb-card__name">${this.esc(item.product_title)}</a>`;
          if (item.variant_title && item.variant_title !== 'Default Title') {
            item.variant_title.split(' / ').forEach(v => {
              subtitleHtml += `<p class="tb-card__meta">${this.esc(v)}</p>`;
            });
          }
        }
        h += `
        <div class="tb-card${isBundle ? ' tb-card--bundle' : ''}" data-key="${item.key}">
          <div class="tb-card__top">
            <a href="${item.url}" class="tb-card__img">
              <img src="${this.img(item.image, '400x')}" alt="${this.esc(item.title)}" loading="lazy">
            </a>
            <div class="tb-card__info">
              <div class="tb-card__head">
                <div>
                  ${nameHtml}
                  ${subtitleHtml}
                </div>
                ${this.priceHtml(item)}
              </div>
            </div>
          </div>
          <div class="tb-card__actions">
            <div class="tb-qty">
              <button class="tb-qty__btn tb-qty__del" data-action="remove" data-key="${item.key}">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>
              </button>
              <button class="tb-qty__btn" data-action="decrease" data-key="${item.key}">-</button>
              <span class="tb-qty__val" data-key="${item.key}">${item.quantity}</span>
              <button class="tb-qty__btn" data-action="increase" data-key="${item.key}">+</button>
            </div>
          </div>
        </div>`;
      });

      h += `<div class="tb-offer" id="tb-offer" style="display:none"></div>`;

      h += `<div class="tb-recs" id="tb-recs" style="display:none">
        <div class="tb-recs__head">
          <h3 class="tb-recs__title">Bunlarla iyi gider</h3>
          <div class="tb-recs__nav">
            <button class="tb-recs__arrow" id="tb-recs-prev"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg></button>
            <button class="tb-recs__arrow" id="tb-recs-next"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg></button>
          </div>
        </div>
        <div class="tb-recs__track" id="tb-recs-track"></div>
      </div>`;

      scroll.innerHTML = h;
      // Restore scroll position post-render (paired with prevScrollTop capture above).
      if (scroll && prevScrollTop > 0) scroll.scrollTop = prevScrollTop;
    }

    renderFooter(cart) {
      const footer = document.querySelector('#tb-footer');
      if (!footer) return;
      footer.style.display = cart.item_count > 0 ? '' : 'none';
      const sub = document.querySelector('#tb-subtotal');
      if (sub) sub.textContent = this.money(cart.total_price);

      // Bundle savings row + strikethrough subtotal
      let originalCents = 0;
      let savingsCents = 0;
      cart.items.forEach((it) => {
        const props = it.properties || {};
        const isBundle = !!props._bundle_label;
        const origRaw = props._bundle_original_price;
        const origMajor = (isBundle && typeof origRaw === 'string' && origRaw.length)
          ? parseFloat(origRaw)
          : NaN;
        if (isBundle && !isNaN(origMajor) && origMajor > 0) {
          const lineOrigCents = Math.round(origMajor * 100 * it.quantity);
          originalCents += lineOrigCents;
          const lineSave = lineOrigCents - it.final_line_price;
          if (lineSave > 0) savingsCents += lineSave;
        } else {
          originalCents += it.final_line_price;
        }
      });

      // Atomic rebuild of the .tb-sub row — avoids piecemeal mutation drift between renders.
      const subRow = document.querySelector('.tb-sub');
      if (subRow) {
        const strikeHtml = savingsCents > 0
          ? `<s class="tb-sub__price--was" id="tb-subtotal-was">${this.money(originalCents)}</s>`
          : '';
        subRow.innerHTML = `
          <span class="tb-sub__label">Ara Toplam:</span>
          <span class="tb-sub__prices">
            ${strikeHtml}
            <span class="tb-sub__price" id="tb-subtotal">${this.money(cart.total_price)}</span>
          </span>`;
      }

      this.renderShipping(cart);
    }

    renderShipping(cart) {
      const LIMIT = 150000;
      const total = cart.total_price;
      const pct = Math.min(Math.round((total / LIMIT) * 100), 100);
      const ship = document.querySelector('#tb-ship');
      const fill = document.querySelector('#tb-ship-fill');
      const text = document.querySelector('#tb-ship-text');

      /* Bos sepette gizle */
      if (ship) ship.style.display = cart.item_count > 0 ? '' : 'none';

      if (fill) fill.style.width = pct + '%';
      if (text) {
        if (total >= LIMIT) {
          text.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2b6b5e" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Harika! <strong>Ücretsiz kargoyla</strong> alıyorsunuz.';
        } else {
          text.innerHTML = 'Ücretsiz kargoya <strong>' + this.money(LIMIT - total) + '</strong> kaldı';
        }
      }

      this.loadFreeShipUpsell(cart);
    }

    /* ===== DRAWER UPSELL ENGINE =====
       Priority-ordered kurallar. İlk eşleşen kazanır.
       Veri: #kc-upsell-data (server-rendered, co-purchase + anchor map).
       Modlar:
         • threshold — "kargo bedava" (gerçekten eşiği geçirir)
         • narrative — anchor-specific outcome pitch ("kaybolmasın", "yaz boyu...")
         • bundle-link — ürün sayfasına link (3'lü set gibi complex adds)
    */
    _getUpsellData() {
      if (this._fsData !== undefined) return this._fsData;
      const blob = document.getElementById('kc-upsell-data');
      if (!blob) { this._fsData = null; return null; }
      try { this._fsData = JSON.parse(blob.textContent); }
      catch (_) { this._fsData = null; }
      return this._fsData;
    }

    _cartHasHandle(cart, handle) {
      return cart.items.some((i) => i.handle === handle);
    }
    _cartHasPrefix(cart, prefix) {
      return cart.items.some((i) => typeof i.handle === 'string' && i.handle.indexOf(prefix) === 0);
    }
    _cartHasAny(cart, handles) {
      const set = new Set(handles);
      return cart.items.some((i) => set.has(i.handle));
    }

    /* Ordered rules. Edit here to add/remove scenarios. */
    _evaluateUpsellRules(cart, data) {
      const LIMIT = 150000;
      const total = cart.total_price;
      const count = cart.item_count;
      const remaining = LIMIT - total;
      const inCartIds = new Set(cart.items.map((i) => i.product_id));

      // Rule R1: Tech Kit in cart + Mystery Pouch yok → anti-loss narrative
      const techKits = ['tech-kit-grove', 'tech-kit-noir', 'tech-kit-ash'];
      if (this._cartHasAny(cart, techKits) && !this._cartHasHandle(cart, 'mystery-pouch')) {
        const p = data.products['mystery-pouch'];
        if (p && !inCartIds.has(p.id)) {
          return { product: p, mode: 'narrative',
            message: 'Küçük parçalar çantada kaybolmasın. <strong>Mystery Pouch</strong> ile topla.' };
        }
      }

      // Rule R2: Solo Mystery Pouch (item_count === 1 + sepetteki ürün mystery-pouch)
      if (count === 1 && this._cartHasHandle(cart, 'mystery-pouch')) {
        const gc = data.products['gocube-valiz-ici-duzenleyici'];
        if (gc) {
          return { product: gc, mode: 'bundle-link',
            link: '/products/gocube-valiz-ici-duzenleyici',
            displayTitle: 'GoCube 3\'lü Set · %15 indirim',
            message: 'Serini tamamla. <strong>3\'lü GoCube</strong> ile kaos biter.' };
        }
      }

      // Rule R3: Gap-fill — cart < 1500, bir partner eşiği geçirebiliyorsa "bedava"
      if (total > 0 && total < LIMIT) {
        const partners = [];
        const seen = new Set();
        cart.items.forEach((it) => {
          const list = data.map && data.map[it.handle];
          if (!Array.isArray(list)) return;
          list.forEach((ph) => { if (!seen.has(ph)) { seen.add(ph); partners.push(ph); } });
        });
        const pickCrosser = (handles) => handles
          .map((h) => data.products[h])
          .filter((p) => p && !inCartIds.has(p.id) && typeof p.price === 'number' && p.price >= remaining)
          .sort((a, b) => a.price - b.price)[0];

        let pick = pickCrosser(partners);
        if (!pick) pick = pickCrosser(data.fallback || []);
        if (pick) {
          return { product: pick, mode: 'threshold',
            message: 'Bunu ekle, kargo <strong>bedava</strong>.' };
        }
        // N2: eşiği geçiren yok → false claim yok → fall through
      }

      // Rule R4: cart ≥ 1500 + (item_count === 1 OR keyring yok) → Rope Keyring promo
      if (total >= LIMIT) {
        const hasKeyring = this._cartHasPrefix(cart, 'everyday-rope-keyring');
        if (!hasKeyring && (count === 1 || !hasKeyring)) {
          const keyringHandles = ['everyday-rope-keyring-acik-mavi', 'everyday-rope-keyring-koyu-mavi',
                                  'everyday-rope-keyring-turuncu', 'everyday-rope-keyring-pembe'];
          for (const h of keyringHandles) {
            const p = data.products[h];
            if (p && !inCartIds.has(p.id)) {
              return { product: p, mode: 'promo',
                message: 'Yaz boyu elinden düşüremeyeceğin <strong>Everyday Rope Keyring</strong>\'i sepetine ekle.' };
            }
          }
        }
      }

      return null;
    }

    loadFreeShipUpsell(cart) {
      const el = document.querySelector('#tb-fs-upsell');
      if (!el) return;

      if (!cart || cart.item_count === 0) {
        el.style.display = 'none';
        el.innerHTML = '';
        return;
      }

      const data = this._getUpsellData();
      if (!data || !data.products) { el.style.display = 'none'; return; }

      const res = this._evaluateUpsellRules(cart, data);
      if (!res || !res.product) {
        el.style.display = 'none';
        el.innerHTML = '';
        return;
      }

      const p = res.product;
      const title = res.displayTitle || p.title;
      const iconSvg = res.mode === 'threshold'
        ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2b6b5e" stroke-width="2.2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>'
        : '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2b6b5e" stroke-width="2.2"><path d="M12 2l2.5 6h6l-5 4.5 2 7L12 15l-5.5 4.5 2-7L3.5 8h6z"/></svg>';

      // Mode-specific action: bundle-link → anchor, narrative/threshold/promo → add button
      const actionHtml = res.mode === 'bundle-link'
        ? `<a class="tb-fs-upsell__btn tb-fs-upsell__btn--link" href="${res.link}" aria-label="Seti gör">
             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><polyline points="9 18 15 12 9 6"/></svg>
           </a>`
        : `<button class="tb-fs-upsell__btn" type="button" data-fs-add data-vid="${p.vid}" aria-label="Sepete ekle">
             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
           </button>`;

      const href = res.link || p.url;
      el.innerHTML = `
        <div class="tb-fs-upsell__head">
          ${iconSvg}
          <span>${res.message}</span>
        </div>
        <div class="tb-fs-upsell__body">
          <a href="${href}" class="tb-fs-upsell__img" aria-label="${this.esc(title)}">
            <img src="${p.image}" alt="${this.esc(title)}" loading="lazy">
          </a>
          <div class="tb-fs-upsell__info">
            <a href="${href}" class="tb-fs-upsell__name">${this.esc(title)}</a>
            <span class="tb-fs-upsell__price">${this.money(p.price)}</span>
          </div>
          ${actionHtml}
        </div>`;
      el.style.display = '';
    }

    /* ===== SLING-ONLY FIXED OFFER (The Rope strap) =====
       Trigger: cart is exactly one line item and it is a Rove Sling.
       Angle: style/customization — swap strap color, change the sling's character. */
    _getRopeOfferData() {
      if (this._ropeData !== undefined) return this._ropeData;
      const blob = document.getElementById('kc-rope-offer');
      if (!blob) { this._ropeData = null; return null; }
      try { this._ropeData = JSON.parse(blob.textContent); }
      catch (_) { this._ropeData = null; }
      return this._ropeData;
    }

    _offerSave(v) {
      const save = (v.was || 0) - (v.offer || 0);
      const pct = v.was ? Math.round(save / v.was * 100) : 0;
      return { save, pct };
    }

    /* Coordinator: pick ONE offer for the #tb-offer slot, by priority.
       1) The Rope strap (sling-specific)  2) Carabiner (broad). */
    /* Render EVERY eligible offer into the #tb-offer slot, stacked in priority
       order (rope on top, carabiner below). Both can show at once. */
    loadOffers(cart) {
      const el = document.querySelector('#tb-offer');
      if (!el) return;
      const handles = ((cart && cart.items) || []).map((i) => i.handle);
      let html = '';
      let ropeShown = false;

      const rope = this._getRopeOfferData();
      if (rope && rope.rope && rope.rope.variants && rope.rope.variants.length
          && handles.some((h) => rope.anchors.indexOf(h) !== -1)
          && !handles.some((h) => h === rope.ropeHandle)) {
        html += this._ropeCardHTML(rope);
        ropeShown = true;
      }

      const carab = this._getCarabinerData();
      // Gift-with-purchase: at/above the threshold the carabiner is claimable free.
      const subtotal = (cart && cart.items_subtotal_price) || 0;
      const giftFree = carab && carab.giftThreshold && subtotal >= carab.giftThreshold;
      if (carab && carab.variants && carab.variants.length
          && !handles.some((h) => h === carab.offerHandle)
          && (giftFree || handles.some((h) => carab.anchors.indexOf(h) !== -1))) {
        html += this._carabCardHTML(carab, handles, giftFree);
      }

      if (!html) {
        el.style.display = 'none';
        el.innerHTML = '';
        this._stopOfferTimer();
        return;
      }
      el.innerHTML = html;
      el.style.display = '';
      if (ropeShown) this._startOfferTimer(rope.timer || 600);
      else this._stopOfferTimer();
    }

    _getCarabinerData() {
      if (this._carabData !== undefined) return this._carabData;
      const blob = document.getElementById('kc-carabiner-offer');
      if (!blob) { this._carabData = null; return null; }
      try { this._carabData = JSON.parse(blob.textContent); }
      catch (_) { this._carabData = null; }
      return this._carabData;
    }

    _carabCardHTML(data, handles, isFree) {
      const vs = data.variants;
      const sel = vs[0];
      const s = this._offerSave(sel);
      const eyebrow = isFree ? 'SEPET HEDİYESİ / 5&#39;Lİ SET' : 'MODÜLER EK / 5&#39;Lİ SET';
      const offTag = isFree ? 'HEDİYE 🎁' : `−%${s.pct} SEPETTE`;
      const nowHtml = isFree ? '<span class="tb-carab__now">ÜCRETSİZ</span>' : `<span class="tb-carab__now">${this.money(sel.offer)}</span>`;
      const ctaTxt = isFree ? 'Hediyeni ekle →' : 'Sisteme ekle →';
      const swatches = vs.map((v, i) =>
        `<button type="button" class="tb-offer__sw${i === 0 ? ' is-sel' : ''}" data-carab-swatch
           data-vid="${v.vid}" data-img="${this.esc(v.img)}" data-offer="${v.offer}" data-was="${v.was}"
           data-color="${this.esc(v.color)}" style="--sw:${v.hex}" title="${this.esc(v.color)}" aria-label="${this.esc(v.color)}"></button>`
      ).join('');
      const fams = [
        { t: (h) => h.indexOf('rove-sling') === 0, l: 'ROVE SLING' },
        { t: (h) => h === 'the-captain-pouch', l: 'CAPTAIN POUCH' },
        { t: (h) => h === 'mystery-pouch', l: 'MYSTERY POUCH' },
        { t: (h) => h.indexOf('all-city') === 0, l: 'ALL CITY' },
        { t: (h) => h.indexOf('tech-kit') === 0, l: 'TECH KIT' },
        { t: (h) => h.indexOf('everyday-rope-keyring') === 0, l: 'ROPE KEYRING' },
      ];
      const present = fams.filter((f) => handles.some((h) => f.t(h))).map((f) => f.l).slice(0, 3);
      const checkBadges = present.map((l) => `<span class="tb-carab__badge"><svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#1f9d55" stroke-width="3.5"><polyline points="20 6 9 17 4 12"/></svg>${l}</span>`).join('');
      return `
        <div class="tb-carab__card${isFree ? ' tb-carab__card--gift' : ''}">
          <div class="tb-carab__strip">
            <span class="tb-carab__eyebrow">${eyebrow}</span>
            <span class="tb-carab__off">${offTag}</span>
          </div>
          <div class="tb-carab__body">
            <a href="${data.url}" class="tb-carab__img" aria-label="5'li Carabiner Set" style="position:relative;display:block;">
              <img src="${this.esc(sel.img)}" alt="5'li Carabiner Set" loading="lazy" data-carab-img>
              <span class="tb-carab__qty" style="position:absolute;top:5px;left:5px;background:#1c1c1c;color:#fff;font-size:11px;font-weight:800;line-height:1;padding:3px 7px;border-radius:999px;letter-spacing:.4px;">×5</span>
            </a>
            <div class="tb-carab__info">
              <h4 class="tb-carab__head">Sistemine kilitlenir.</h4>
              <p class="tb-carab__sub">5 alüminyum tak-çıkar karabina. Pouch'unu, anahtarını, cüzdanını — hepsini çantana sabitle.</p>
            </div>
          </div>
          <div class="tb-offer__colorrow">
            <span class="tb-offer__collabel">Renk</span>
            <div class="tb-offer__sw-row">${swatches}</div>
            <span class="tb-offer__colname" data-carab-colname>${this.esc(sel.color)}</span>
          </div>
          <span class="tb-carab__complabel">Şunlarla uyumlu:</span>
          <div class="tb-carab__badges">
            <span class="tb-carab__badge tb-carab__badge--all"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#C4632E" stroke-width="2.4"><path d="M10 13a5 5 0 007 0l3-3a5 5 0 00-7-7l-1.5 1.5"/><path d="M14 11a5 5 0 00-7 0l-3 3a5 5 0 007 7l1.5-1.5"/></svg>HEMEN HER ŞEYE</span>
            ${checkBadges}
          </div>
          <div class="tb-carab__spec">5'Lİ SET · ALÜMİNYUM ALAŞIM · SÜPER HAFİF</div>
          <div class="tb-carab__foot">
            <div class="tb-carab__price">
              ${nowHtml}
              <s class="tb-carab__was">${this.money(sel.was)}</s>
            </div>
            <button class="tb-carab__cta" type="button" data-fs-add data-vid="${sel.vid}">${ctaTxt}</button>
          </div>
        </div>`;
    }

    _ropeCardHTML(data) {
      const r = data.rope;
      const vs = r.variants;
      const sel = vs[0];
      const s = this._offerSave(sel);
      const swatches = vs.map((v, i) =>
        `<button type="button" class="tb-offer__sw${i === 0 ? ' is-sel' : ''}" data-rope-swatch
           data-vid="${v.vid}" data-img="${this.esc(v.img)}" data-offer="${v.offer}" data-was="${v.was}"
           data-color="${this.esc(v.color)}" style="--sw:${v.hex}" title="${this.esc(v.color)}" aria-label="${this.esc(v.color)}"></button>`
      ).join('');

      return `
        <div class="tb-offer__card">
          <div class="tb-offer__top">
            <span class="tb-offer__badge"><i></i>SEPETİNE ÖZEL</span>
            <span class="tb-offer__fam">ROVE SLING AİLESİ</span>
          </div>
          <div class="tb-offer__body">
            <a href="${r.url}" class="tb-offer__img" aria-label="${this.esc(r.title)}">
              <img src="${this.esc(r.lifestyle || sel.img)}" alt="${this.esc(r.title)}" loading="lazy">
            </a>
            <div class="tb-offer__info">
              <span class="tb-offer__kicker">${this.esc(r.title)}</span>
              <h4 class="tb-offer__head">Aynı Sling, farklı günler için</h4>
              <p class="tb-offer__sub">Gerçek dağcı paracordundan örülü, Rove sling'ini farklı stillerde kullanmak için</p>
            </div>
          </div>
          <div class="tb-offer__colorrow">
            <span class="tb-offer__collabel">Renk</span>
            <div class="tb-offer__sw-row">${swatches}</div>
            <span class="tb-offer__colname" id="tb-offer-colname">${this.esc(sel.color)}</span>
          </div>
          <div class="tb-offer__price">
            <span class="tb-offer__now" id="tb-offer-now">${this.money(sel.offer)}</span>
            <s class="tb-offer__was" id="tb-offer-was">${this.money(sel.was)}</s>
            <span class="tb-offer__tag" id="tb-offer-tag">%${s.pct} · ${this.money(s.save)}</span>
          </div>
          <button class="tb-offer__btn" type="button" data-fs-add data-vid="${sel.vid}" id="tb-offer-add">Sepete özel fiyata ekle</button>
          <div class="tb-offer__timer">
            <i></i><span>Bu fiyat bu sepette geçerli</span> <b id="tb-offer-clock">10:00</b>
          </div>
        </div>`;
    }

    selectCarabSwatch(sw) {
      const card = sw.closest('.tb-carab__card');
      if (!card) return;
      card.querySelectorAll('[data-carab-swatch]').forEach(s => s.classList.remove('is-sel'));
      sw.classList.add('is-sel');
      const d = sw.dataset;
      const name = card.querySelector('[data-carab-colname]');
      const img = card.querySelector('[data-carab-img]');
      const cta = card.querySelector('[data-fs-add]');
      if (name && d.color) name.textContent = d.color;
      if (img && d.img) img.src = d.img;
      if (cta && d.vid) cta.dataset.vid = d.vid;
      // Gift mode shows ÜCRETSİZ — leave price nodes alone in that state.
      if (!card.classList.contains('tb-carab__card--gift') && d.offer && d.was) {
        const now = card.querySelector('.tb-carab__now');
        const was = card.querySelector('.tb-carab__was');
        if (now) now.textContent = this.money(parseInt(d.offer, 10));
        if (was) was.textContent = this.money(parseInt(d.was, 10));
      }
    }

    selectRopeSwatch(sw) {
      const row = sw.closest('.tb-offer__sw-row');
      if (row) row.querySelectorAll('.tb-offer__sw').forEach(s => s.classList.remove('is-sel'));
      sw.classList.add('is-sel');
      const d = sw.dataset;
      const now = document.getElementById('tb-offer-now');
      const was = document.getElementById('tb-offer-was');
      const tag = document.getElementById('tb-offer-tag');
      const name = document.getElementById('tb-offer-colname');
      const add = document.getElementById('tb-offer-add');
      if (now && d.offer) now.textContent = this.money(parseInt(d.offer, 10));
      if (was && d.was) was.textContent = this.money(parseInt(d.was, 10));
      if (name && d.color) name.textContent = d.color;
      if (add && d.vid) add.dataset.vid = d.vid;
      if (tag && d.was && d.offer) {
        const save = parseInt(d.was, 10) - parseInt(d.offer, 10);
        const pct = Math.round(save / parseInt(d.was, 10) * 100);
        tag.textContent = `%${pct} · ${this.money(save)}`;
      }
    }

    /* Per-session countdown for the sling offer (soft urgency). */
    _startOfferTimer(secs) {
      this._stopOfferTimer();
      const KEY = 'kc_rope_deadline';
      let deadline = parseInt(localStorage.getItem(KEY) || '0', 10);
      const now = Date.now();
      if (!deadline || deadline < now) {
        deadline = now + secs * 1000;
        localStorage.setItem(KEY, String(deadline));
      }
      const clock = () => {
        const el = document.getElementById('tb-offer-clock');
        if (!el) return this._stopOfferTimer();
        let left = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        const m = String(Math.floor(left / 60)).padStart(2, '0');
        const s = String(left % 60).padStart(2, '0');
        el.textContent = `${m}:${s}`;
      };
      clock();
      this._offerTick = setInterval(clock, 1000);
    }
    _stopOfferTimer() {
      if (this._offerTick) { clearInterval(this._offerTick); this._offerTick = null; }
    }

    updateBubble(cart) {
      // Focal uses <cart-count> custom elements (header__cart-count).
      // Cover multiple theme conventions defensively.
      const selectors = [
        'cart-count',
        '.header__cart-count',
        '.cart-count',
        '[data-cart-count]',
        '.js-cart-count',
        '.Header__CartCount',
        '.bubble-count',
      ];
      const n = cart.item_count;
      document.querySelectorAll(selectors.join(',')).forEach((el) => {
        el.textContent = n;
        // Focal toggles visibility on .is-hidden / aria-hidden when count is 0
        if (n === 0) {
          el.setAttribute('aria-hidden', 'true');
          el.classList.add('is-hidden');
        } else {
          el.removeAttribute('aria-hidden');
          el.classList.remove('is-hidden');
        }
      });
      // Let any external listeners (Focal internals, analytics) react.
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true, detail: { cart },
      }));
    }

    /* ===== RECOMMENDATIONS ===== */
    async loadRecs(cart) {
      if (cart.item_count === 0) {
        // Cart emptied — clear the fingerprint so a re-populated cart with the
        // same product set (e.g. user removed then re-added the same item)
        // doesn't short-circuit below and leave the recs slot empty.
        this._recsFingerprint = null;
        return;
      }

      // Debounce: skip refetch if cart product set is unchanged. Every qty +/-
      // used to fire 5 parallel /recommendations calls — wasteful on mobile.
      const fingerprint = cart.items.map(i => i.product_id).sort().join(',');
      const recsEl = document.querySelector('#tb-recs');
      const track = document.querySelector('#tb-recs-track');
      // Skip refetch only if the cart set is unchanged AND the track is still
      // populated. renderItems() rebuilds #tb-scroll (emptying the track), so a
      // plain fingerprint check would leave the carousel permanently empty after
      // any re-render (qty change, offer refresh) — this is why "Bunlarla iyi
      // gider" vanished. Repopulate whenever the track is empty.
      if (this._recsFingerprint === fingerprint && track && track.children.length) return;
      this._recsFingerprint = fingerprint;
      if (!recsEl || !track) return;

      const cartIds = new Set(cart.items.map(i => i.product_id));
      let allRecs = [];

      /* Paralel API cagrilari */
      /* Her sepet urununden 10 oneri cek */
      const fetches = cart.items.slice(0, 5).map(item =>
        fetch(`/recommendations/products.json?product_id=${item.product_id}&limit=10&intent=related`)
          .then(r => r.ok ? r.json() : { products: [] })
          .catch(() => ({ products: [] }))
      );
      const results = await Promise.all(fetches);
      results.forEach(d => { if (d.products) allRecs = allRecs.concat(d.products); });

      /* Tekrar + sepetteki urunleri cikar */
      const seen = new Set(cartIds);
      const unique = [];
      for (const p of allRecs) {
        if (!seen.has(p.id) && p.available) { seen.add(p.id); unique.push(p); }
        if (unique.length >= 12) break;
      }

      /* Fallback */
      if (unique.length < 3) {
        try {
          const r = await fetch('/collections/all/products.json?limit=12');
          if (r.ok) {
            const d = await r.json();
            (d.products || []).forEach(p => {
              if (!seen.has(p.id) && p.images?.length) {
                seen.add(p.id);
                unique.push({
                  id: p.id, title: p.title, url: '/products/' + p.handle,
                  price: p.variants?.[0]?.price ? Math.round(parseFloat(p.variants[0].price) * 100) : 0,
                  featured_image: p.images[0]?.src || '',
                  available: true, variants: p.variants || [], options: p.options || [],
                });
              }
            });
          }
        } catch (e) {}
      }

      if (unique.length === 0) { recsEl.style.display = 'none'; return; }

      recsEl.style.display = '';
      track.innerHTML = unique.map(p => {
        const imgSrc = typeof p.featured_image === 'string' ? p.featured_image : '';
        const firstVar = p.variants?.[0];
        const vid = firstVar?.id;
        const swatches = this.buildSwatches(p);

        /* Fiyat: indirimli mi? */
        let priceHtml = '';
        const currentPrice = typeof p.price === 'number' ? p.price : parseInt(p.price) || 0;
        const comparePrice = p.compare_at_price
          || firstVar?.compare_at_price
          || (typeof p.compare_at_price_max === 'number' ? p.compare_at_price_max : 0);
        const compareCents = typeof comparePrice === 'number' ? comparePrice
          : (typeof comparePrice === 'string' ? Math.round(parseFloat(comparePrice) * 100) : 0);

        if (compareCents > 0 && compareCents > currentPrice) {
          priceHtml = `<div class="tb-rec__prices">
            <span class="tb-rec__price tb-rec__price--sale">${this.money(currentPrice)}</span>
            <s class="tb-rec__price tb-rec__price--was">${this.money(compareCents)}</s>
          </div>`;
        } else {
          priceHtml = `<span class="tb-rec__price">${this.money(currentPrice)}</span>`;
        }

        return `
        <div class="tb-rec">
          <a href="${p.url}" class="tb-rec__img">
            <img src="${this.img(imgSrc, '400x')}" alt="${this.esc(p.title)}" loading="lazy">
          </a>
          <div class="tb-rec__body">
            <div class="tb-rec__top">
              <a href="${p.url}" class="tb-rec__name">${this.esc(p.title)}</a>
              ${priceHtml}
            </div>
            ${swatches}
            ${vid ? `<button class="tb-rec__add" data-vid="${vid}">Sepete Ekle</button>` : `<span class="tb-rec__sold">Tükendi</span>`}
          </div>
        </div>`;
      }).join('');
    }

    buildSwatches(product) {
      const variants = product.variants;
      if (!variants || variants.length <= 1) return '';

      const opts = product.options || product.options_with_values || [];
      let colorIdx = -1;

      for (let i = 0; i < opts.length; i++) {
        const raw = opts[i];
        const name = typeof raw === 'string' ? raw : (raw?.name || raw?.title || '');
        if (/color|colour|renk|farbe|szin/i.test(name)) { colorIdx = i; break; }
      }

      if (colorIdx === -1) {
        const uniq1 = new Set(variants.map(v => v.option1).filter(Boolean));
        if (uniq1.size > 1) colorIdx = 0;
      }

      if (colorIdx === -1) return '';

      const seen = new Set();
      const colors = [];
      variants.forEach(v => {
        let val;
        if (colorIdx === 0) val = v.option1 || (v.options && v.options[0]);
        else if (colorIdx === 1) val = v.option2 || (v.options && v.options[1]);
        else val = v.option3 || (v.options && v.options[2]);

        if (val && !seen.has(val)) {
          seen.add(val);
          const rawImg = v.featured_image?.src || v.image?.src || v.featured_image || '';
          const img = typeof rawImg === 'string' ? rawImg : '';
          const price = v.price || 0;
          const compare = v.compare_at_price || 0;
          colors.push({ name: val, img, vid: v.id, price, compare });
        }
      });

      if (colors.length <= 1) return '';

      return '<div class="tb-rec__swatches">' + colors.slice(0, 10).map((c, i) =>
        `<span class="tb-rec__swatch${!c.img ? ' tb-rec__swatch--color' : ''}${i === 0 ? ' is-active' : ''}"
          title="${this.esc(c.name)}"
          data-swatch-vid="${c.vid}"
          data-swatch-img="${c.img ? this.img(c.img, '400x') : ''}"
          data-swatch-price="${c.price}"
          data-swatch-compare="${c.compare}"
          ${!c.img ? `style="background:${this.nameToColor(c.name)}"` : ''}>
          ${c.img ? `<img src="${this.img(c.img, '60x')}" alt="${this.esc(c.name)}">` : ''}
        </span>`
      ).join('') + '</div>';
    }

    selectSwatch(swatch) {
      const card = swatch.closest('.tb-rec');
      if (!card) return;

      /* Aktif swatch'i guncelle */
      card.querySelectorAll('.tb-rec__swatch').forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      /* Kart resmini degistir */
      const newImg = swatch.dataset.swatchImg;
      if (newImg) {
        const imgEl = card.querySelector('.tb-rec__img img');
        if (imgEl) { imgEl.src = newImg; imgEl.alt = swatch.title; }
      }

      /* "Sepete Ekle" butonundaki variant ID'yi degistir */
      const vid = swatch.dataset.swatchVid;
      const addBtn = card.querySelector('.tb-rec__add');
      if (addBtn && vid) { addBtn.dataset.vid = vid; }

      /* Fiyati guncelle */
      const price = parseInt(swatch.dataset.swatchPrice) || 0;
      const compare = parseInt(swatch.dataset.swatchCompare) || 0;
      const priceArea = card.querySelector('.tb-rec__top');
      if (priceArea) {
        /* Mevcut fiyat elementlerini bul */
        const existingPrices = priceArea.querySelector('.tb-rec__prices') || priceArea.querySelector('.tb-rec__price');
        let newPriceHtml;
        if (compare > 0 && compare > price) {
          newPriceHtml = `<div class="tb-rec__prices">
            <span class="tb-rec__price tb-rec__price--sale">${this.money(price)}</span>
            <s class="tb-rec__price tb-rec__price--was">${this.money(compare)}</s>
          </div>`;
        } else {
          newPriceHtml = `<span class="tb-rec__price">${this.money(price)}</span>`;
        }
        if (existingPrices) {
          existingPrices.outerHTML = newPriceHtml;
        }
      }
    }

    scrollRecs(dir) {
      const track = document.querySelector('#tb-recs-track');
      if (!track) return;
      const card = track.querySelector('.tb-rec');
      if (!card) return;
      track.scrollBy({ left: dir * (card.offsetWidth + 14), behavior: 'smooth' });
    }

    /* ===== SAVE ===== */
    saveCart() {
      this.getCart().then(cart => {
        localStorage.setItem('savedCart', JSON.stringify({
          items: cart.items.map(i => ({ id: i.variant_id, qty: i.quantity, title: i.product_title })),
          date: new Date().toISOString(),
        }));
        this.toast('Sepet kaydedildi');
      });
    }

    /* ===== HELPERS ===== */

    /* Sepet karti fiyat HTML'i - compare_at_price + discount kontrol */
    priceHtml(item) {
      const final = item.final_line_price;
      const original = item.original_line_price;
      const compareAt = item.compare_at_price || 0;
      const qty = item.quantity;
      const isBundle = !!(item.properties && item.properties._bundle_label && item.properties._bundle_original_price);

      // Bundle original price comes from Cart Transform attribute `_bundle_original_price`
      // (per-unit, MAJOR units). Drawer multiplies by qty. Discount pct may be decimal (12.5).
      let bundleOriginalCents = 0;
      let bundlePct = 0;
      if (isBundle && item.properties) {
        const op = parseFloat(item.properties._bundle_original_price);
        if (!isNaN(op) && op > 0) bundleOriginalCents = Math.round(op * 100 * qty);
        const dp = parseFloat(item.properties._bundle_discount_pct);
        if (!isNaN(dp) && dp > 0) bundlePct = dp;
      }

      let savingsLabel = '';
      let strikePrice = null;
      if (isBundle && bundleOriginalCents > final) {
        const savings = bundleOriginalCents - final;
        const pct = bundlePct || Math.round((savings / bundleOriginalCents) * 100);
        savingsLabel = `<span class="tb-card__savings">%${pct} Tasarruf · ${this.money(savings)}</span>`;
        strikePrice = bundleOriginalCents;
      } else if (!isBundle && original > final) {
        const savings = original - final;
        const pct = Math.round((savings / original) * 100);
        savingsLabel = `<span class="tb-card__savings">%${pct} Tasarruf · ${this.money(savings)}</span>`;
        strikePrice = original;
      }

      if (compareAt > 0 && compareAt > item.final_price && !isBundle) {
        const compareTotal = compareAt * qty;
        return `<div class="tb-card__prices">
          <span class="tb-card__price tb-card__price--sale">${this.money(final)}</span>
          <s class="tb-card__price tb-card__price--was">${this.money(compareTotal)}</s>
          ${savingsLabel}
        </div>`;
      } else if (strikePrice && strikePrice > final) {
        return `<div class="tb-card__prices">
          <span class="tb-card__price tb-card__price--sale">${this.money(final)}</span>
          <s class="tb-card__price tb-card__price--was">${this.money(strikePrice)}</s>
          ${savingsLabel}
        </div>`;
      }
      return `<div class="tb-card__prices"><span class="tb-card__price">${this.money(final)}</span></div>`;
    }

    money(cents) {
      if (typeof cents !== 'number') cents = parseInt(cents) || 0;
      // Use Intl for proper TR thousands separator (12.345,67 instead of 12345,67).
      // Cached formatter — Intl.NumberFormat is expensive to construct per-call.
      if (!this._fmtMoney) {
        try {
          this._fmtMoney = new Intl.NumberFormat('tr-TR', {
            style: 'currency', currency: 'TRY', currencyDisplay: 'symbol',
            minimumFractionDigits: 2, maximumFractionDigits: 2,
          });
        } catch (_) { this._fmtMoney = null; }
      }
      if (this._fmtMoney) return this._fmtMoney.format(cents / 100);
      return (cents / 100).toFixed(2).replace('.', ',') + ' ₺';
    }

    img(url, size) {
      if (!url) return '';
      const m = url.match(/\.(jpg|jpeg|gif|png|bmp|tiff|tif|webp)(\?.*)?$/i);
      if (m) return url.replace(m[0], '_' + size + '.' + m[1] + (m[2] || ''));
      return url;
    }

    esc(s) {
      if (!s) return '';
      const d = document.createElement('div'); d.textContent = s; return d.innerHTML;
    }

    wait(ms) { return new Promise(r => setTimeout(r, ms)); }

    nameToColor(name) {
      const n = (name || '').toLowerCase().replace(/[^a-zığüşöç]/g, '');
      const map = {
        black:'#222',siyah:'#222',white:'#f5f5f5',beyaz:'#f5f5f5',red:'#c0392b',kırmızı:'#c0392b',
        blue:'#2980b9',mavi:'#2980b9',green:'#27ae60',yeşil:'#27ae60',yellow:'#f1c40f',sarı:'#f1c40f',
        orange:'#e67e22',turuncu:'#e67e22',purple:'#8e44ad',mor:'#8e44ad',pink:'#e91e63',pembe:'#e91e63',
        gray:'#95a5a6',grey:'#95a5a6',gri:'#95a5a6',brown:'#8d6e63',kahverengi:'#8d6e63',
        navy:'#2c3e50',lacivert:'#2c3e50',beige:'#d4c5a9',bej:'#d4c5a9',cream:'#f5f0e1',krem:'#f5f0e1',
        teal:'#008080',coral:'#ff7f50',bordo:'#800020',burgundy:'#800020',
        gold:'#ffd700',silver:'#c0c0c0',gümüş:'#c0c0c0',haki:'#8b8b40',ash:'#b2beb5',
      };
      return map[n] || '#ccc';
    }

    toast(msg) {
      document.querySelector('.tb-toast')?.remove();
      const t = document.createElement('div'); t.className = 'tb-toast'; t.textContent = msg;
      document.body.appendChild(t);
      setTimeout(() => { t.style.opacity = '0'; t.style.transition = 'opacity .3s'; setTimeout(() => t.remove(), 300); }, 2500);
    }

    loading(on) {
      let l = this.drawer.querySelector('.tb-loading');
      if (!l) { l = document.createElement('div'); l.className = 'tb-loading'; l.innerHTML = '<div class="tb-spinner"></div>'; this.drawer.appendChild(l); }
      l.classList.toggle('is-on', on);
    }
  }

  const bootstrap = () => { window.kcCartDrawer = new TBDrawer(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootstrap);
  else bootstrap();
})();
